<div class="flex lg:flex-col justify-center mt-10"
    *ngIf="lilate && (lilate.status !== 'done' && lilate.status !== 'abs_student_without_justification' && lilate.examination_session_status != 'pending_assessment')">
    <fuse-card class="flex flex-col lg:flex-row lg:max-w-400">
        <!-- BLOC GAUCHE -->
        <div
            class="flex flex-col items-center p-8 lg:px-10 lg:py-12 lg:min-w-80 bg-gray-100 dark:bg-black dark:bg-opacity-10">
            <!-- CAS PLANIFIÉ ET PB IDENITÉ -->
            <ng-container
                *ngIf="(lilate.status == 'booked' || lilate.status == 'identity_issue') && lilate.examination_session_status != 'pending_assessment'">
                <app-lilate-card-booked *ngIf="lilate.status == 'booked'" [bloc]="'gauche'"
                    [lilate]="lilate"></app-lilate-card-booked>
                <app-lilate-card-identity-issue *ngIf="lilate.status == 'identity_issue'" [bloc]="'gauche'"
                    [lilate]="lilate"></app-lilate-card-identity-issue>
            </ng-container>

            <!-- <ng-container *ngIf="lilate.examination_session_status === 'pending_assessment'">
                <app-lilate-card-pending_assessment [bloc]="'gauche'"
                    [lilate]="lilate"></app-lilate-card-pending_assessment>
            </ng-container> -->

            <!-- CAS À PLANIFIER OU ANNULER PAR PROF -->
            <ng-container *ngIf="(lilate.status === 'pending_booking' || lilate.status == 'cancelled_by_teacher')">
                <app-lilate-card-pending-booking *ngIf="lilate.status == 'pending_booking'" [bloc]="'gauche'"
                    [lilate]="lilate"></app-lilate-card-pending-booking>
                <app-lilate-card-cancelled-by-teacher *ngIf="lilate.status == 'cancelled_by_teacher'" [bloc]="'gauche'"
                    [lilate]="lilate"></app-lilate-card-cancelled-by-teacher>
            </ng-container>
        </div>

        <!--- BLOC DROIT --->
        <div class="p-6 sm:p-8 lg:p-10">
            <div class="flex items-center font-bold">
                <div class="flex w-1/12"><img src="{{lilate.language.flag}}" alt="language-flag"></div>
                <div class="text-2xl w-11/12 ml-5">
                    <div translate [translateParams]="{language:lilate.language.label}">lilate-exam.certif.name.1</div>

                    <div class="text-gray-700 text-base font-normal" *ngIf="lilate.in_training" translate
                        [translateParams]="{start: lilate.validity_period_from | parisDay, end: lilate.validity_period_to | parisDay}">
                        lilate-exam.date-slot-time
                    </div>
                    <div class="text-gray-700 text-base font-normal" *ngIf="lilate.expired_date" translate
                        [translateParams]="{date: lilate.expired_date | parisDay}">
                        lilate-exam.deadline-date
                    </div>
                    <div class="text-gray-700 text-base font-normal" *ngIf="lilate.company">{{ lilate.company.name }}</div>
                </div>
            </div>

            <!--<div>
                <div class="mt-4 leading-relaxed text-gray-700">{{ lilate.company.name }}</div>
                <div *ngIf="lilate.in_training">Formation du {{ lilate.validity_period_from | date:'dd/MM/yyyy' }} au {{ lilate.validity_period_to | date:'dd/MM/yyyy' }}</div>
            </div>-->

            <ng-container *ngIf="lilate.status === 'pending_booking' || lilate.status == 'cancelled_by_teacher'">
                <app-lilate-card-pending-booking *ngIf="lilate.status == 'pending_booking'" [bloc]="'droite'"
                    [lilate]="lilate"></app-lilate-card-pending-booking>
                <app-lilate-card-cancelled-by-teacher *ngIf="lilate.status == 'cancelled_by_teacher'" [bloc]="'droite'"
                    [lilate]="lilate"></app-lilate-card-cancelled-by-teacher>
            </ng-container>

            <ng-container
                *ngIf="(lilate.status == 'booked' || lilate.status == 'identity_issue') && lilate.examination_session_status != 'pending_assessment' ">
                <app-lilate-card-booked *ngIf="lilate.status == 'booked'" [bloc]="'droite'"
                    [lilate]="lilate"></app-lilate-card-booked>
                <app-lilate-card-identity-issue *ngIf="lilate.status == 'identity_issue'" [bloc]="'droite'"
                    [lilate]="lilate"></app-lilate-card-identity-issue>
            </ng-container>

            <!-- ASSESSMENT EN COURS -->
            <!-- <ng-container *ngIf="lilate.examination_session_status == 'pending_assessment'">
                <app-lilate-card-pending_assessment [bloc]="'droite'"
                    [lilate]="lilate"></app-lilate-card-pending_assessment>
            </ng-container> -->
        </div>
    </fuse-card>
</div>



<!-- CAS ASSESSMENT EN COURS -->
<fuse-card *ngIf="lilate && lilate.status === 'done'" class="flex flex-col max-w-80 w-full p-6 h-full">
    <app-lilate-card-done *ngIf="lilate.status === 'done'" [lilate]="lilate"></app-lilate-card-done>
</fuse-card>

<!-- CAS ABSENCE CANDIDAT -->
<fuse-card *ngIf="lilate && lilate.status === 'abs_student_without_justification'"
    class="flex flex-col max-w-80 w-full p-6 h-full">
    <app-lilate-card-absent *ngIf="lilate.status === 'abs_student_without_justification'"
        [lilate]="lilate"></app-lilate-card-absent>
</fuse-card>

<!-- CAS ASSESSMENT EN COURS -->
<fuse-card *ngIf="lilate && lilate.examination_session_status === 'pending_assessment'"
    class="flex flex-col max-w-80 w-full p-6 h-full">
    <app-lilate-card-pending-assessment *ngIf="lilate && lilate.examination_session_status === 'pending_assessment'"
        [lilate]="lilate"></app-lilate-card-pending-assessment>
</fuse-card>